import React from 'react';
import { Box } from '@material-ui/core';

// eslint-disable-next-line react/prefer-stateless-function
// eslint-disable-next-line react/prop-types
export default function SumaryHourStats({ summaryHours }) {
  const hourStatRender = (item, index) => (
    <Box
      flexShrink={1}
      flexGrow={0}
      className="summary-hours-stats"
      key={`summary_${index}`}
      p={0}
      name={item.name}
      duration={item.duration.hours * 60 + item.duration.minutes}
    >
      <span className="stat-number">{item.duration.hours}</span>
      <span className="stat-number-sufix">h</span>&nbsp;
      <span className="stat-number">{item.duration.minutes}</span>
      <span className="stat-number-sufix">m</span>
      <div className="summary-text">{item.name}</div>
    </Box>
  );

  return summaryHours !== null ? <React.Fragment>{summaryHours.map(hourStatRender)}</React.Fragment> : null;
}
